module.exports = __webpack_public_path__ + "media/images/icon__xco--rb-gray-b67aea34e8a3575b69c173c19e99ac61.png";